import { usePlatformContext } from "providers/Auth/platform.provider";
import qs from "qs";
import { FC } from "react";
import { useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { PageTitle } from "../../layout-components/PageTitle/page-title";
import { AvailableBaseRoutes } from "../../utils/constants";
import { GroupDetailContent } from "./components/group-detail-content.component";

export interface IGroupDetailParams {
  erpNumber: string | undefined;
}

export const GroupDetailPage: FC = () => {
  const { erpNumber } = useParams<IGroupDetailParams>();
  const location = useLocation();
  const { activePlatform } = usePlatformContext();

  const createUserOnLoadString = qs.parse(location.search, { ignoreQueryPrefix: true }).createUserOnLoad as
    | string
    | undefined;
  const createUserOnLoad = createUserOnLoadString === "true";

  if (!erpNumber) return null;

  return (
    <>
      <PageTitle id={AvailableBaseRoutes.GroupDetail} />
      <GroupDetailContent
        erpNumber={erpNumber}
        platform={activePlatform}
        createUserOnLoad={createUserOnLoad}
      />
    </>
  );
};
